import { 
    CreateTravelVoucherDto, 
    DeleteTravelVoucherDto,
    EditTravelVoucherDto,
    GetTravelVoucherDto, 
    MessageResponseDto, 
    TravelVoucherApiFp,
    TravelVoucherControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseTravelVoucherModel = TravelVoucherControllerGet200Response;
export type GetTravelVoucherModel = GetTravelVoucherDto;
export type MutateResponseTravelVoucherModel = MessageResponseDto;
export type CreateTravelVoucherModel = CreateTravelVoucherDto;
export type UpdateTravelVoucherModel = EditTravelVoucherDto;
export type DeleteTravelVoucherModel = DeleteTravelVoucherDto;

export const apiTravelVoucherFp = TravelVoucherApiFp(apiConfig);
export const getTravelVoucherController = apiTravelVoucherFp.travelVoucherControllerGet;
export const createTravelVoucherController = apiTravelVoucherFp.travelVoucherControllerCreate;
export const updateTravelVoucherController = apiTravelVoucherFp.travelVoucherControllerEdit;
export const deleteTravelVoucherController = apiTravelVoucherFp.travelVoucherControllerDelete;

export const QueryKeyTravelVoucher = QueryKey.TravelVoucher;